import { render, staticRenderFns } from "./ElectionRegistration.vue?vue&type=template&id=6868bb9e"
import script from "./ElectionRegistration.vue?vue&type=script&lang=js"
export * from "./ElectionRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports